import { atom } from 'jotai';

import { TournamentStatus, TournamentTeams, Maybe } from '@/types';

export const tournamentAtom = atom<
  Maybe<{
    tournamentTeamsMap: Map<number, TournamentTeams>;
    tournamentStatusMap: Map<number, TournamentStatus>;
  }>
>(null);
